import { MagnifyingGlassSolid } from '@allocab/allocab-icons';
import { useMemo, useState } from 'react';

import { InvoiceCard } from './InvoiceCard';
import { Invoice } from './types';
import { TextInput } from '../../components/atomic/TextInput';
import { Spinner } from '../../components/Spinner';
import { t } from '../../services/translation/translation';

type Props = {
  invoices: Invoice[];
  isLoading: boolean;
  isFetching: boolean;
  title: string;
};

export const InvoicesCards = ({ invoices, isLoading, isFetching, title }: Props) => {
  const [driverQuery, setDriverQuery] = useState('');

  const filteredInvoices = useMemo<Invoice[]>(() => {
    return invoices
      .filter(i => i.invoiceNumber !== 'Pas de facture')
      .filter(i =>
        driverQuery.length > 0
          ? !!i.driverName?.toLocaleLowerCase().includes(driverQuery.toLocaleLowerCase()) ||
            !!i.subject?.toLocaleLowerCase().includes(driverQuery.toLocaleLowerCase())
          : true,
      )
      .sort((a, b) => (a.creationDate > b.creationDate ? 1 : -1));
  }, [driverQuery, invoices]);

  return (
    <div>
      {isLoading ? (
        <Spinner />
      ) : (
        <div>
          {!isLoading && !isFetching && (filteredInvoices?.length ?? 0) === 0 ? (
            <div>
              <div className="p-5 text-lg font-semibold text-left text-gray-900 bg-white dark:text-white dark:bg-gray-800">
                <div className="flex gap-2 items-start">
                  <div className="flex-1">{title}</div>
                </div>
              </div>
              <div className="flex flex-col items-center justify-center py-4 w-full bg-white dark:bg-gray-800">
                <div className="h-96 w-96 bg-confused-light dark:bg-confused-dark bg-no-repeat bg-contain bg-center" />
                <p className="mt-2 text-md text-gray-500 dark:text-gray-400">{t('common.no-results')}</p>
              </div>
            </div>
          ) : (
            <div className="mt-3 ">
              {filteredInvoices.length > 0 ? (
                <div>
                  <div className="p-5 text-lg font-semibold text-left text-gray-900 bg-white dark:text-white dark:bg-gray-800">
                    <div className="flex gap-2 items-start">
                      <div className="flex-1">{title}</div>
                    </div>
                  </div>
                  <TextInput
                    placeholder={t('invoicing-route.search-driver')}
                    className="min-w-full xl:w-56 xl:min-w-0"
                    value={driverQuery}
                    onChange={e => setDriverQuery(e.currentTarget.value)}
                    icon={<MagnifyingGlassSolid width={16} height={16} className="fill-current" />}
                  />
                </div>
              ) : null}
              <div className="space-y-2 mt-2">
                {filteredInvoices.map(invoice => (
                  <InvoiceCard key={invoice.id} invoice={invoice} />
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
